import { render, staticRenderFns } from "./password-change-component.vue?vue&type=template&id=28b7e3fc&scoped=true"
import script from "./password-change-component.vue?vue&type=script&lang=js"
export * from "./password-change-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7e3fc",
  null
  
)

export default component.exports